import { UserGroupScope } from '@shared/models/user-group.model'
import { BaseModel } from './base.model'
import { User } from './user.model'

export class Integration extends BaseModel {
  id: number
  name: string
  status: IntegrationModelStatus
  data?: {
    data: {
      apiKey: string
      accountToken: string
      businessToken?: string
      owner_id?: string
    }
    scope: {
      type: UserGroupScope
      value: number[]
    }
    id: number
    team: {
      id: number
    }
    status: string
    lastUpdatedAt: string | null
  }

  constructor(src?: Integration) {
    super(src)
  }
}

export enum IntegrationModelStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
  RequireData = 'require_data',
}

export interface IntegrationModelData {
  data?: {
    apiKey?: string
    accountToken?: string
    licenseKey?: string
    xFunctionsKey?: string
    businessToken?: string
    owner_id?: string
  }
  scope?: {
    type: UserGroupScope
    value: number[]
  }
}

export interface IntegrationFormData {
  apiKey?: string
  accountToken?: string
  licenseKey?: string
  xFunctionsKey?: string
  ownerId?: string
  scope: UserGroupScope
  scopeValues: User[]
  value: number[]
}

export interface IntegrationModel extends Integration {
  description?: string
  logo?: string
  status: IntegrationModelStatus
}

export interface IntegrationData {
  [key: string]: { logo: string; description: string; isKey: boolean; isScope: boolean; link: string }
}

export enum IntegrationTypes {
  Solbox = 'solbox',
  Logmaster = 'logmaster',
  Fleetio = 'fleetio',
  Prism = 'prism',
  Vwork = 'vwork',
  Fuse = 'fuse',
  LinxioVision = 'linxiovision',
  Gearbox = 'gearbox',
  Project44 = 'project44',
}

export interface IntegrationUpdateResponse extends IntegrationModelData {
  id: number
  name: string
  integration: Pick<Integration, 'id' | 'name'>
  team: {
    id: number
  }
  scope: {
    id: 1
    value: number[]
    type: UserGroupScope
  }
  status: IntegrationModelStatus
}

export interface IntegrationFormData {
  scope: UserGroupScope
  scopeValues: User[]
  value: number[]
  apiKey?: string
  accountToken?: string
  licenseKey?: string
  xFunctionsKey?: string
  businessToken?: string
  ownerId?: string
}

export enum ConfigureType {
  Keys = 'keys',
  Scope = 'scope',
}
